const actionTypes = { SET_HOME_PAGE: 'SET_HOME_PAGE' };

module.exports = actionTypes;
